<rk-app-configuration-submenu
  (submenuSelected)="onSelectSubmenu($event)"
></rk-app-configuration-submenu>
<rk-setting-divider></rk-setting-divider>
@if (selectedSubMenu === 'content') {
  <rk-player-content></rk-player-content>
}
@if (selectedSubMenu === 'design') {
  <rk-player-design></rk-player-design>
}
